import * as React from 'react';
import { overlappingCardDriverFactory } from './OverlappingCard.driver';
import { OverlappingCard, OverlappingCardRatioOptions } from '.';
import { createRendererWithUniDriver } from '../../test/utils';

describe('OverlappingCard', () => {
  const createDriver = createRendererWithUniDriver(
    overlappingCardDriverFactory,
  );

  it('should render info', async () => {
    const textContent = 'info!';
    const value = <div>{textContent}</div>;
    const { driver } = createDriver(<OverlappingCard info={value} />);
    expect((await driver.getInfoContent()).innerHTML).toEqual(textContent);
  });

  it('should render image', async () => {
    const textContent = 'image!';
    const value = <div>{textContent}</div>;
    const { driver } = createDriver(<OverlappingCard media={value} />);
    expect((await driver.getMediaContent()).innerHTML).toEqual(textContent);
  });

  it('should render ratio 50 as default', async () => {
    const { driver } = createDriver(
      <OverlappingCard info="info" media="media" />,
    );
    expect(await driver.getRatio()).toEqual(
      OverlappingCardRatioOptions.RATIO_50_50,
    );
  });

  it('should render ratio 40', async () => {
    const { driver } = createDriver(
      <OverlappingCard
        ratio={OverlappingCardRatioOptions.RATIO_40_60}
        info="info"
        media="media"
      />,
    );
    expect(await driver.getRatio()).toEqual(
      OverlappingCardRatioOptions.RATIO_40_60,
    );
  });

  it('should render ratio 30', async () => {
    const { driver } = createDriver(
      <OverlappingCard
        ratio={OverlappingCardRatioOptions.RATIO_30_70}
        info="info"
        media="media"
      />,
    );
    expect(await driver.getRatio()).toEqual(
      OverlappingCardRatioOptions.RATIO_30_70,
    );
  });

  it('should render ratio 100 if there is no media', async () => {
    const { driver } = createDriver(<OverlappingCard info="info" />);
    expect(await driver.getRatio()).toEqual(
      OverlappingCardRatioOptions.RATIO_100,
    );
  });

  it('should flipped the ratio', async () => {
    const { driver } = createDriver(<OverlappingCard flippedRatio />);
    expect(await driver.isFlippedRatio()).toEqual(true);
  });

  it('should invert the image position', async () => {
    const { driver } = createDriver(<OverlappingCard invertInfoPosition />);
    expect(await driver.isImagePositionInverted()).toEqual(true);
  });
});
